"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fi = require("react-icons/fi");

var _Button = _interopRequireDefault(require("../../../../../Button/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SendButton = function SendButton(_ref) {
  var disabled = _ref.disabled,
      processUserMessage = _ref.processUserMessage,
      handleReset = _ref.handleReset;
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "primary",
    colorIcon: "white",
    icon: _fi.FiSend,
    iconRight: true,
    type: "button",
    sizeIcon: "25px",
    widthButton: "45px",
    disabled: disabled,
    onClick: function onClick() {
      processUserMessage();
      handleReset();
    }
  });
};

SendButton.propTypes = {
  disabled: _propTypes.default.bool.isRequired,
  processUserMessage: _propTypes.default.func.isRequired,
  handleReset: _propTypes.default.func.isRequired
};
var _default = SendButton;
exports.default = _default;